// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3bIvz","inner":"Footer_inner__2andV"};